<ng-container *ngIf="uploadedDocs$ | async as uploadedDocs; else noDocs">
	<ui-section
		[title]="title"
		[isEmpty]="uploadedDocs.length === 0"
		emptyMessage="No {{ title }}"
		[data-intercom-target]="dataIntercomTarget"
		[testHook]="testHooks.UploadedDocumentsSection"
	>
		<ui-button
			title-action
			(click)="upload()"
			label="Upload"
			icon="upload"
			preset="MEDIUM_EMPHASIS"
			[testHook]="testHooks.UploadButton"
		/>
		<div section-content class="space-y-2">
			<ui-card
				*ngFor="let doc of uploadedDocs"
				(click)="openPDF(doc)"
				class="hover:bg-gray-50 duration-300 cursor-pointer"
			>
				<div card-content>
					<div class="flex gap-4">
						<div
							class="w-9 h-9 bg-blue-100 rounded-full flex items-center justify-center"
						>
							<i-tabler name="file-text" class="text-blue-600 w-4 h-4" />
						</div>
						<div class="space-y-1">
							<h6 class="h6 mb-0">{{ doc.name }}</h6>
							<p class="p-xs">Uploaded, {{ doc.uploadedAt | closerDate }}</p>
						</div>
					</div>
				</div>
			</ui-card>
		</div>
	</ui-section>
</ng-container>
<ng-template #noDocs>
	<ui-section
		title="No {{ title }}"
		emptyMessage="No {{ title }}"
		[testHook]="testHooks.NoDocumentsSection"
	>
	</ui-section>
</ng-template>
